// Kinio KMS 操作台插進既有畫面的小元件（插入點：殼層選單、組織設定頁）；頁面本身在各自的檔案。
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { MyOrg } from '../../lib/planeApi';
import { useKmgrNav, useOrgKmgrStatus } from './hooks';
import { NS } from './parts';

/** 選單「事故」旁的未處理事故數（有未處理緊急時紅色，否則灰色；跟「事件與警報」的警報數分開）。 */
export function KmgrNavBadge() {
  const { t } = useTranslation(NS);
  const { unhandled, p1Unhandled } = useKmgrNav();
  if (!unhandled) return null;
  return (
    <span
      className={'nav-badge' + (p1Unhandled ? ' alarm' : '')}
      style={p1Unhandled ? undefined : { background: 'var(--surface-2)', color: 'var(--text)', border: '1px solid var(--border)' }}
      data-testid="kmgr-unhandled"
      title={t('nav.unhandled_n', { n: unhandled })}
    >
      {unhandled > 99 ? '99+' : unhandled}
    </span>
  );
}

/** 組織設定頁的「IT 監控」卡（組織 owner / org_admin；讀得到 kmgr 才畫）。 */
export function KmgrOrgCard({ org }: { org: MyOrg }) {
  const { t } = useTranslation(NS);
  const admin = org.role === 'owner' || org.role === 'org_admin';
  const st = useOrgKmgrStatus(admin ? org : undefined);
  if (!admin || !st.data) return null;
  const n = st.data.homes.filter((h) => h.kmgr_enabled).length;
  return (
    <section className="card km" data-testid="km-org-card">
      <div className="toolbar">
        <h2 className="section-title" style={{ margin: 0 }}>
          {t('org.title')}
        </h2>
        <div className="spacer" />
        <Link className="btn btn-sm" to="/org/kmgr">
          {n ? t('org.manage') : t('org.start_wizard')}
        </Link>
      </div>
      <p className="muted km-sub" style={{ margin: 0 }}>
        {n ? t('org.card_enabled', { n }) : t('org.card_none')}
      </p>
    </section>
  );
}
